import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { Program } from '@/types/global';

interface GlobalState {
  meData: Record<string, any>;
  token: string;
  program: Program;
  themeColor: string;
  programLogo: string;
  manufacturerLogo: string;
  updateMeData: (value: Record<string, any>) => void;
  updateProgram: (state: Program) => void;
  updateToken: (value: string) => void;
  updateTheme: (value: string) => void;
  updateProgramLogo: (value: string) => void;
  updateManufacturerLogo: (value: string) => void;
}

const useGlobalConfig = create<GlobalState>()(
  devtools(
    persist(
      (set) => ({
        meData: JSON.parse(localStorage.getItem('meData') || '{}'),
        token: localStorage.getItem('Authorization') || '',
        program: JSON.parse(localStorage.getItem('Program') || '{}'),
        themeColor: localStorage.getItem('themeColor') || '',
        programLogo: localStorage.getItem('programLogo') || '',
        manufacturerLogo: localStorage.getItem('manufacturerLogo') || '',
        updateMeData: (value: Record<string, any>) =>
          set(() => {
            return {
              meData: value,
            };
          }),
        updateProgram: (state: Program) =>
          set(() => {
            return {
              program: state,
            };
          }),
        updateToken: (value: string) =>
          set(() => {
            return {
              token: value,
            };
          }),
        updateTheme: (value: string) =>
          set(() => {
            return {
              themeColor: value,
            };
          }),
        updateProgramLogo: (value: string) =>
          set(() => {
            return {
              programLogo: value,
            };
          }),
        updateManufacturerLogo: (value: string) =>
          set(() => {
            return {
              manufacturerLogo: value,
            };
          }),
      }),
      {
        name: 'provider-global', // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    )
  )
);

export default useGlobalConfig;
